import { useCallback, useState } from 'react'

type Props = {
            Component?: any,
            onCloseFunction?: () => void,
            refreshFunction?: (data?: any) => void,
            company?: any,
            submitting?: boolean,
            onSubmit?: ()=> void
}
const useCompanyDirModal = ({
  Component,
  onCloseFunction = null,
  company,
  submitting,
  onSubmit,
  refreshFunction
}: Props) => {
  const [info, setInfo] = useState({
    id: null,
    data: null,
    open: false
  })

  const openModal = useCallback((id, data) => {
    setInfo({
      id,
      data,
      open: true
    })
  }, [])

  const closeModal = useCallback(() => {
    setInfo({
      id: null,
      data: null,
      open: false
    })
  }, [])

  return {
    content: info?.open ? (
      <Component
        company={company}
        submitting={submitting}
        onSubmit={onSubmit}
        refreshFunction={refreshFunction}
        onCloseFunction={onCloseFunction}
        id={info?.id}
        open={info.open}
        onClose={closeModal}
        initialForm={info.data}
      />
    ) : null,
    openModal,
    open: info.open
  }
}

export default useCompanyDirModal
